export const network = {
  title: 'SynthoNetwork',
  subtitle: 'Reliable Network Solutions',
  hero: {
    title: 'High Performance Network',
    subtitle: 'IT & DE Coverage',
    description: 'Secure IP Transit Solutions'
  },
  whyUs: {
    title: 'Why Us?',
    description: 'We focus heavily on improving our services. While we may not be the best yet, we\'re working hard to get there. Our constant commitment to improvement and attention to customer needs sets us apart in the industry.'
  },
  contact: {
    title: 'How You Can Connect With Us',
    description: 'Reach out to us via email or phone. Our team is ready to assist you with any inquiries.',
    company: {
      name: 'MULTI SERVICE S.R.L.S.',
      address: 'Via Isonzo 102 - 73055 Racale (LE)',
      vat: 'P.IVA / VAT.ID IT 05316380756',
      rea: 'REA: LE - 358063'
    }
  },
  lookingGlass: {
    title: 'Looking Glass',
    description: 'Check network connectivity and routing information',
    tools: [
      {
        name: 'Ping Test',
        description: 'Test connectivity to a target host'
      },
      {
        name: 'Traceroute',
        description: 'View network path to destination'
      },
      {
        name: 'BGP Route',
        description: 'Check BGP routing information'
      }
    ]
  },
  services: {
    title: 'Our Services',
    description: 'Comprehensive network and hosting solutions',
    items: [
      {
        title: 'Game Hosting',
        description: 'Low-latency game server hosting with DDoS protection'
      },
      {
        title: 'VPS Hosting',
        description: 'High-performance virtual servers with dedicated resources'
      },
      {
        title: 'Dedicated Servers',
        description: 'Powerful dedicated hardware for demanding applications'
      }
    ]
  },
  pricing: {
    title: 'Network Pricing',
    description: 'Competitive rates for premium network services',
    contact: 'Contact us for custom quotes'
  },
  prefixes: {
    title: 'Network Prefixes',
    description: 'View our network prefixes and ASN information',
    table: {
      location: 'Location',
      subnet: 'Subnet',
      type: 'Network Type',
      description: 'Description'
    },
    networks: [
      {
        location: 'Germany',
        subnet: '194.36.26.0/24',
        type: 'IPv4',
        description: 'SynthoHosting - DE Location'
      },
      {
        location: 'Germany',
        subnet: '2a0d:b287:ec00::/40',
        type: 'IPv6',
        description: 'SynthoHosting - DE Location'
      }
    ]
  }
};